export default __webpack_public_path__ + "static/media/arrow_btn_back_light.8a49b694.svg";